import type { SVGProps } from 'react';
const SvgAdminPanelSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#admin_panel_settings_svg__a)">
      <path d="M17 11c.34 0 .67.04 1 .09V6.27L10.5 3 3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82.55-.13 1.08-.32 1.6-.55-.69-.98-1.1-2.17-1.1-3.45 0-3.31 2.69-6 6-6Z" />
      <path d="M17 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm0 1.38c.62 0 1.12.51 1.12 1.12 0 .61-.51 1.12-1.12 1.12-.61 0-1.12-.51-1.12-1.12 0-.61.5-1.12 1.12-1.12Zm0 5.37c-.93 0-1.74-.46-2.24-1.17.05-.72 1.51-1.08 2.24-1.08.73 0 2.19.36 2.24 1.08-.5.71-1.31 1.17-2.24 1.17Z" />
    </g>
    <defs>
      <clipPath id="admin_panel_settings_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAdminPanelSettings;
